/**
 * Overflow Mode.
 * @public
 */
enum ExpandableTextOverflowMode {
	/**
	 * Overflowing text is appended in-place.
	 * @public
	 */
	InPlace = "InPlace",

	/**
	 * Full text is displayed in a popover.
	 * @public
	 */
	Popover = "Popover",
}

export default ExpandableTextOverflowMode;
